import type { IUser } from 'src/api/users-api';

export function getMessageSenderName(owner: number, currentUser: IUser) {
    if (owner === currentUser.id) {
        return 'You';
    }

    const teamMemberFistNameMap = new Map (
        currentUser.leasing_team_members?.map((member) => [
            member.id,
            member.name.split(' ')[0]
        ])
    );

    // If owner is not the current user, return the owner's first name
    return teamMemberFistNameMap.get(owner) || 'Unknown';
}